@if(taxaOpcional && taxaOpcional.valor > 0) {
  <div 
    class="vip-selectable-card bg-white rounded vip-border py-2 px-3 mb-3 cursor-pointer"
    (click)="onToggle()"
    role="button"
    tabindex="0"
    (keydown.enter)="onToggle()"
  >
    <div class="flex items-center" style="margin-bottom: 10px;">
      <i class="icon-attach_money text-xl vip-color-secondary-main mr-2"></i>
      <p class="font-medium text-base vip-color-first-default">{{ taxaOpcional.tituloTaxa }}</p>
    </div>

    <div class="mb-4 vip-color-secondary-default text-sm leading-tight text-left">
      {{ taxaOpcional.descricao }}
    </div>

    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <vip-checkbox 
          size="sm"
          [checkboxValue]="isTaxaOpcionalSelecionada" 
          (changeCheckout)="onToggle()"
          (click)="$event.stopPropagation()"
          tabindex="-1"
          arialabel="Selecionar taxa opcional"
        ></vip-checkbox>
        <span class="vip-color-secondary-default text-sm">Aceitar</span>
      </div>
      <span class="font-medium text-sm vip-color-success-main">
        {{ taxaOpcional.valor | currency:'BRL' }}
      </span>
    </div>
  </div>
}
